import Card from '@material-ui/core/Card';
import { DocumentTemplateList } from 'components/DocumentTemplates';
import { AppReferenceManyField } from "components/list/AppReferenceManyField";
import React from 'react';
import { Edit, SimpleForm, TabbedShowLayout, Tab } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { UserRole } from '../../../entities/';
import { TerminalsEditForm } from './EditForm';
import { InternalPalletLabelsTab } from './InternalPalletLabelsTab';

export const TerminalsEdit = (props) => {
    if (!props.permissions) {
        return null;
    }

    const canEditTerminal = props.permissions.role === UserRole.admin;

    if (!canEditTerminal) {
        return <InternalPalletLabelsTab {...props} canEditLabelSettings={false} />;
    }

    return (
        <TabbedShowLayout style={{paddingBottom: 8}} basePath={props.basePath}>
            <Tab label="tab.geneneral.name" >
                <Edit {...props} undoable={false}>
                    <SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />}>
                        <TerminalsEditForm />
                    </SimpleForm>
                </Edit>
            </Tab>
            <Tab label="tab.document-template-default.name" path="document-templates">
                <Card>
                    <AppReferenceManyField label={false} fullWidth reference="document-templates" filter={{"terminal_id": props.id}}
                    >
                        <DocumentTemplateList isDefaultDocTemplate={true} {...props}/>
                    </AppReferenceManyField>
                </Card>
            </Tab>
            <Tab label="tab.internal-pallet-labels.name" path="internal-pallet-labels">
                <InternalPalletLabelsTab {...props} canEditLabelSettings={true} />
            </Tab>
        </TabbedShowLayout>
    );
};
